module.exports = __webpack_public_path__ + "media/adeste.822300d2.mp3";